export default __webpack_public_path__ + "static/miles-43cd5f9b29bcb35bc45a2ef824dadda3.svg";